var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterOutline2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#32325D",
    d: "M10 13.253c.027.2-.04.414-.193.554-.125.124-.294.195-.47.195-.177 0-.346-.07-.47-.195l-2.674-2.674c-.147-.144-.219-.348-.193-.553V7.167L2.807 3.08c-.226-.29-.175-.706.113-.933.127-.094.267-.147.413-.147h9.334c.146 0 .286.053.413.147.288.227.339.644.113.933L10 7.167v6.086m-5.307-9.92l2.64 3.374v3.68l1.334 1.333V6.7l2.64-3.367H4.693z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H11V16H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOutline2);
export default __webpack_public_path__ + "static/media/filter-outline-2.e5ef40f583c13e9ea10914a69a17e764.svg";
export { ForwardRef as ReactComponent };